export default __webpack_public_path__ + "static/home-bg-0c8487b1600416d37fd075513c431224.png";